/**
 * List of users
 */
class Friends{
     constructor(settings) {
        this.locked=false;
        this._value='';
        this.searchTimer=null;

        var that = this;

        this.container = $("#list-content");
        this.resultsContainer = this.container.find('#people-list-results');
        this.list = this.resultsContainer.length ? this.resultsContainer.find('ul') : $('ul', this.container);
        this.noItems = this.resultsContainer.length ? this.resultsContainer.find('#no-items') : this.container.find('div.message');

        this.container.find('form').submit(function() {
            return false;
        });

        this.texts = settings.texts;
        this.parent = settings.parent;
        this.searchUrl = settings.searchUrl || null;
        this.eventId = settings.eventId || null;
        this.openedTab = 0;

        if (this.searchUrl) {
            this.container.find('form > input').on('input', function() {
                that.scheduleSearch($(this).val());
            });

            this.resultsContainer.on('click', '.people-list__pagination-link[data-page]', function(e) {
                e.preventDefault();
                that.search(that.container.find('form > input').val(), parseInt($(this).data('page'), 10) || 1);
            });
        } else {
            this.container.find('form > input').keyup(function() {
                that.filter($(this).val().toLowerCase());
            });
        }

        if (!$('.friends-list').length) $('div.container').addClass('low');
    }

    scheduleSearch(term) {
        var that = this;
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(function() {
            that.search(term, 1);
        }, 300);
    }

    search(term, page) {
        var that = this;

        if (!this.searchUrl || this.locked) {
            return;
        }

        page = page || 1;
        term = term === undefined || term === null ? '' : term;

        this._value = term;
        this._lock();
        this.resultsContainer.addClass('is-loading');

        $.ajax({
            url: this.searchUrl,
            dataType: 'json',
            type: 'post',
            data: {
                id: this.eventId,
                search: term,
                page: page
            },
            success: function(data) {
                if (data && data.html !== undefined) {
                    that.resultsContainer.html(data.html);
                    that.list = that.resultsContainer.find('ul');
                    that.noItems = that.resultsContainer.find('#no-items');
                }
                that._unlock();
                that.resultsContainer.removeClass('is-loading');
            },
            error: function() {
                that._unlock();
                that.resultsContainer.removeClass('is-loading');
            }
        });
    }

    _lock() {
        this.locked = true;
    }

    _unlock() {
        this.locked = false;
    }

    filter(value) {
        var that = this;
        var count = 0;

        if (this.searchUrl) {
            return;
        }

        if (value == undefined) {
            value = this._value;
        } else {
            this._value = value;
        }

        this.list.find('li').each(function() {
            var match = false;
            var name = $(this).find('.user').text().toLowerCase();
            var names = name.split(' ');

            if(name.indexOf(value) == 0) {
                match = true;
            }
            else {
                for(var i = 0; i < names.length; i++) {
                    if(names[i].indexOf(value) == 0) {
                        match = true;
                        break;
                    }
                }
            }

            if(match) {
                count++;
                $(this).css('display', 'block');
            }
            else {
                $(this).css('display', 'none');
            }
        });

        if(!count) {
            that.list.css('paddingBottom', '0px');
            that.noItems.css('display', 'block');
        } else {
            that.list.css('paddingBottom', '10px');
            that.noItems.css('display', 'none');
        }
    }

    _changeFriend(userId, status, callback, msg) {
        var that = this;
        that._lock();

        if (msg == undefined || !msg) {
            msg = this.texts.areYouSureRemove;
        }

        if (status) {
            $.ajax({
                url: "/profile/change-friend/", dataType: 'json', type: 'post',
                data: {user_id: userId, status: '1'},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        callback(data);
                        that._unlock();
                    } else that._unlock();
                }
            });
        } else {
            if (!window.confirm(msg)) {
                that._unlock();
                return;
            }

            $.ajax({
                url: "/profile/change-friend/", dataType: 'json', type: 'post',
                data: {user_id: userId, status: '0'},
                success: function(data) {
                    if (data && data.success != undefined && data.success) {
                        callback(data);
                        that._unlock();
                    } else that._unlock();
                }
            });
        }
    }

    friendToggle(userId, deleteOnUnfriend) {
        var that = this;
        var status = 1;
        if (deleteOnUnfriend == undefined || !deleteOnUnfriend) deleteOnUnfriend = false;
        else deleteOnUnfriend = true;

        if ($("#friend-btn-" + userId).hasClass("unfriend")) {
            status = 0;
        } else {
            status = 1;
        }

        this._changeFriend(userId, status, function() {
            if (status) {
                $("#friend-btn-" + userId).removeClass("friend").addClass("unfriend").addClass("primary");
                $("#friend-btn-" + userId).after($("#message-btn-" + userId));
                $("#message-btn-" + userId).removeClass("primary");
                $("#user-" + userId).addClass("pending").addClass("requesting");
                var txt = $("#user-" + userId + " .location").html();
                $("#user-" + userId + " .location").html(that.texts.waiting).data("oldloc", txt);
                that.filter();
            } else {
                if (deleteOnUnfriend) {
                    $("#user-" + userId).fadeOut(300, function() {
                        $("#user-" + userId).remove();
                        that.filter();
                    });
                } else {
                    $("#friend-btn-" + userId).removeClass("unfriend").addClass("friend").removeClass("primary");
                    $("#friend-btn-" + userId).before($("#message-btn-" + userId));
                    $("#message-btn-" + userId).addClass("primary");
                    if ($("#user-" + userId).hasClass('pending')) {
                        $("#user-" + userId).removeClass('pending');
                        if ($("#user-" + userId).hasClass('requesting')) {
                            $("#user-" + userId).removeClass('requesting');

                            $("#user-" + userId + " .location").html($("#user-" + userId + " .location").data("oldloc"));
                        }
                    }
                    that.filter();
                }
            }
        });
    }

    friend(userId) {
        var that = this;

        this._changeFriend(userId, 1, function() {
            $("#unfriend-btn-" + userId).remove();
            $("#friend-btn-" + userId).removeClass("friend").addClass("unfriend").before($("#message-btn-" + userId));
            $("#friend-btn-" + userId).removeClass('primary').attr("onclick", "window.usersList.friendToggle(" + userId + "); return false;");
            $("#message-btn-" + userId).addClass('primary');

            if ($("#user-" + userId).hasClass('pending')) {
                $("#user-" + userId).removeClass('pending');
                if ($("#user-" + userId).hasClass('requesting')) {
                    $("#user-" + userId).removeClass('requesting');
                }
            }

            $("#user-" + userId + " .location").html($("#user-" + userId + " .location").data("oldloc"));
            that.filter();
        });
    }

    unfriend(userId, deleteOnUnfriend) {
        var that = this;
        if (deleteOnUnfriend == undefined || !deleteOnUnfriend) deleteOnUnfriend = false;
        else deleteOnUnfriend = true;

        this._changeFriend(userId, 0, function() {
            if (deleteOnUnfriend) {
                $("#user-" + userId).fadeOut(300, function() {
                    $("#user-" + userId).remove();
                    that.filter();
                });
            } else {
                $("#unfriend-btn-" + userId).remove();
                $("#friend-btn-" + userId).before($("#message-btn-" + userId));
                $("#friend-btn-" + userId).removeClass('primary').attr("onclick", "window.usersList.friendToggle(" + userId + "); return false;");
                $("#message-btn-" + userId).addClass('primary');

                if ($("#user-" + userId).hasClass('pending')) {
                    $("#user-" + userId).removeClass('pending');
                    if ($("#user-" + userId).hasClass('requesting')) {
                        $("#user-" + userId).removeClass('requesting');
                    }
                }

                $("#user-" + userId + " .location").html($("#user-" + userId + " .location").data("oldloc"));
                that.filter();
            }

        }, this.texts.areYouSureReject);
    }

    openFriendsTab(parent) {
        var that = this;

        if(that.openedTab == 1 || that.locked) return;
        that.openedTab = 1;
        that._lock();

        $('form', '#list-content').addClass('hidden').find('input').val('').attr('placeholder', this.texts.searchFriendsPlaceholder);
        $('ul', '#list-content').html(that.texts.loadingFriends);
        $('div.message', '#list-content').hide();

        $.ajax({
            url: '/profile/load-friends/',
            dataType: 'json',
            method: 'post',
            data: {
                id: $('#list-content').data('user')
            },
            success: function(data) {
                if (data) {
                    $('#list-content ul').html(data);
                    that.parent = parent;
                    that._unlock();
                }
            }
        });
    }

    openSuggestedTab(parent) {
        var that = this;

        if(that.openedTab == 2 || that.locked) return;
        that.openedTab = 2;
        that._lock();

        $('form', '#list-content').addClass('hidden').find('input').val('');
        $('ul', '#list-content').html(that.texts.loadingSuggested);
        $('div.message', '#list-content').hide();

        $.ajax({
            url: '/profile/load-suggested-friends/',
            dataType: 'json',
            method: 'post',
            data: {
                id: $('#list-content').data('user')
            },
            success: function(data) {
                if (data) {
                    $('#list-content ul').html(data);
                    that.parent = parent;
                    that._unlock();
                }
            }
        });
    }

    openMutualFriendsTab(parent) {
        var that = this;

        if(that.openedTab == 3 || that.locked) return;
        that.openedTab = 3;
        that._lock();

        $('form', '#list-content').addClass('hidden').find('input').val('');
        $('ul', '#list-content').html(that.texts.loadingMutual);
        $('div.message', '#list-content').hide();

        $.ajax({
            url: '/profile/load-mutual-friends/',
            dataType: 'json',
            method: 'post',
            data: {
                id: $('#list-content').data('user')
            },
            success: function(data) {
                if (data) {
                    $('#list-content ul').html(data);
                    that.parent = parent;
                    that._unlock();
                }
            }
        });
    }

    openInviteTab(parent) {
        var that = this;

        if(that.openedTab == 4 || that.locked) return;
        that.openedTab = 4;
        that._lock();

        $('form', '#list-content').addClass('hidden').find('input').val('').attr('placeholder', this.texts.searchFacebookFriendsPlaceholder);
        $('ul', '#list-content').html(that.texts.loadingFacebookFriends);
        $('div.message', '#list-content').hide();

        $.ajax({
            url: '/profile/load-invite-friends/',
            dataType: 'json',
            method: 'post',
            data: {
                id: $('#list-content').data('user')
            },
            success: function(data) {
                if (data) {
                    $('#list-content ul').html(data);
                    that.parent = parent;
                    that._unlock();
                }
            }
        });
    }

    sendFacebookMessage(to, name, o) {
        if (!o.hasClass('friend'))
            return false;

        var safari = /safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase());
        var top = $(window).scrollTop();

        FB.ui({
            method: 'send',
            to: [to],
            name: name + ' has sent you a friend request on Plentix',
            description: 'Discover the events you love!',
            link: 'http://app.plentix.co'
        }, function() {
            if(!safari) $('html, body').animate({ scrollTop: top }, { duration: 100, queue: false });
            window.evedo.enablePageScrolling();
        });

        if(!safari) $('html, body').animate({ scrollTop: 0 }, { duration: 100, queue: false });
        window.evedo.disablePageScrolling();
    }

    sendFacebookInvitation(to, name, target) {
        if (target.parent('li').hasClass('invited')) return;

        var safari = /safari/.test(navigator.userAgent.toLowerCase()) && !/chrome/.test(navigator.userAgent.toLowerCase());
        var that = this;
        var top = $(window).scrollTop();

        FB.ui({
            method: 'send',
            to: [to],
            name: name + ' has invited you to join Plentix',
            description: 'Discover the events you love!',
            link: 'http://app.plentix.co'
        }, function(response) {
            if (response) {
                target.parent('li').addClass('invited').find('span').text(that.texts.invited);
                $.ajax({
                    url: '/profile/facebook-invitees/friend/',
                    dataType: 'json',
                    method: 'post',
                    async: false,
                    data: {
                        requestId: to
                    },
                    success: function(data) {
                    }
                });
            }

            if(!safari) $('html, body').animate({ scrollTop: top }, { duration: 100, queue: false });
            window.evedo.enablePageScrolling();
        });

        if(!safari) $('html, body').animate({ scrollTop: 0 }, { duration: 100, queue: false });
        window.evedo.disablePageScrolling();
    }
}

export { Friends }
